export const tableRules = {
  actualCost: [{ required: true, message: '维修实际费用必填', trigger: 'blur' }],
  completeDate: [{ required: true, message: '完工日期必填', trigger: 'blur' }],
};
